"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var InteractionTypes = _interopRequireWildcard(require("customer-data-communicator/schema/interactions/InteractionTypes"));

var _react = require("react");

var _default = _react.PropTypes.oneOf(Object.keys(InteractionTypes).map(function (key) {
  return InteractionTypes[key];
}));

exports.default = _default;
module.exports = exports.default;